export class KPStandard {
    public static DANGEROUS_KP: number = 5;
}